import '.e1{font-size:1.125rem;}.ssr-plugin'
import '.d4{line-height:1.75rem;}.ssr-plugin'
import '.fq{text-decoration:none;}.ssr-plugin'
import '.fk{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="e1 d4"
    >
      {translations.privacySubtitle}{' '}
      <a className="fq fk"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="fq fk"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
